import React, { useState } from "react";

function DragAndDropFileUpload() {
  const [files, setFiles] = useState([]);

  const handleFileChange = (event) => {
    const selectedFiles = Array.from(event.target.files);
    setFiles((prevFiles) => [...prevFiles, ...selectedFiles]);
  };

  const handleFileRemove = (index) => {
    const updatedFiles = files.filter((_, i) => i !== index);
    setFiles(updatedFiles);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const droppedFiles = Array.from(event.dataTransfer.files);
    setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
  };

  return (
    <div>
      <div className="bg"
        onDragOver={handleDragOver}
        onDrop={handleDrop}
        style={{
          border: "2px dashed #ddd",
          padding: "20px",
          borderRadius: "5px",
          textAlign: "center",
          marginBottom: "20px",
          backgroundColor: "#eeeeee",
        }}
      >
        <p>Drag and drop files here, or click to select files</p>
        <input
          type="file"
          multiple
          onChange={handleFileChange}
          style={{ display: "none" }}
          id="fileInput"
        />
        <label
          htmlFor="fileInput"
          style={{
            background: "#007bff",
            color: "white",
            padding: "10px 20px",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Browse Files
        </label>
      </div>

      <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
        {files.map((file, index) => (
          <div
            key={index}
            style={{
              border: "1px solid #ddd",
              padding: "10px",
              borderRadius: "5px",
              textAlign: "center",
              width: "100px",
            }}
          >
            {file.type.startsWith("image/") ? (
              <img
                src={URL.createObjectURL(file)}
                alt={file.name}
                style={{
                  width: "100%",
                  height: "100px",
                  objectFit: "cover",
                  marginBottom: "10px",
                }}
              />
            ) : (
              <p>{file.name}</p>
            )}
            <button
              onClick={() => handleFileRemove(index)}
              style={{
                background: "red",
                color: "white",
                border: "none",
                cursor: "pointer",
                padding: "5px 10px",
                borderRadius: "3px",
              }}
            >
              Delete
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default DragAndDropFileUpload;
